export const resetPasswordResourcePath = "/reset_password";
export const resetPasswordResourceType = "reset_password_request";
